class TableOfContents {
  constructor() {
    this.articleInner = document.querySelector('.article-body__inner');
    this.articleBody = document.querySelector('.article-body__content');

    const headingArray = this.findHeadings(this.articleBody);

    if (headingArray.length > 0) {
      this.nav = document.querySelector('.article-body__nav');
      this.nav.classList.add('article-body__nav--display');

      this.articleNavList = document.querySelector('ul.article-body__nav-list');
    }

    this.updateHeadingID(headingArray);
    this.updateNavItem(this.articleNavList, headingArray);
  }

  findHeadings(articleBody) {
    this.headingArray = articleBody.getElementsByTagName('h2');
    return this.headingArray;
  }

  updateHeadingID(headingArray) {
    headingArray.forEach(heading => {
      const headingText = heading.innerText.replace(/[^\w\s]+/g, '');
      const sanitizedText = headingText.replace(/[^a-zA-Z0-9]/g, '-');
      heading.setAttribute('id', sanitizedText);
    });
  }

  updateNavItem(articleNavList, headingArray) {
    const numHeadings = headingArray.length;
    for (let currentItem = 0; currentItem < numHeadings; currentItem++) {
      const newNavItem = document.createElement('li');
      newNavItem.setAttribute('class', 'article-body__nav-item');

      const navItemLink = document.createElement('a');
      navItemLink.setAttribute('class', 'article-body__nav-link');

      navItemLink.innerHTML = headingArray[currentItem].innerText;
      const headingText = headingArray[currentItem].innerText.replace(/[^\w\s]+/g, '');
      const sanitizedText = headingText.replace(/[^a-zA-Z0-9]/g, '-');
      const navItemHref = `#${sanitizedText}`;

      navItemLink.setAttribute('href', navItemHref);

      newNavItem.appendChild(navItemLink);
      articleNavList.appendChild(newNavItem);
    }
  }
}

export default TableOfContents;
